<template>
    <v-dialog v-model="addClientDialog" @keydown.esc="addClientDialog = false" persistent max-width="600px" retain-focus>
        <template v-slot:activator="{ on, addClientAttrs }">
            <v-btn :color="buttonColor" class="mr-5" dark v-bind="addClientAttrs" v-on="on">
                <span v-if="buttonText" class="mr-2">{{ buttonText }}</span>
                <v-icon>mdi-account-plus</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">거래처 등록</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" class="mb-n8">
                            <v-text-field label="거래처명 *" hint="거래처명을 입력하세요." v-model="clientAttrs.clientName" ref="client-name" @focus="$event.target.select()" @focusout="checkDuplicateName" required></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mb-n8">
                            <v-text-field label="브랜드명" hint="드랜브명을 입력하세요." v-model="clientAttrs.clientBrand"></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mb-n8">
                            <v-text-field label="연락처 *" hint="연락처를 입력하세요." v-model="clientAttrs.clientPhone" required></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field label="이메일" hint="이메일 주소를 입력하세요." v-model="clientAttrs.clientEmail"></v-text-field>
                        </v-col>
                        <v-textarea
                                class="px-3 mb-n8"
                                outlined
                                label="비 고"
                                v-model="clientAttrs.clientComment"
                        ></v-textarea>
                    </v-row>
                </v-container>
                <small>* 항목은 필수입니다.</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="saveClient">저장</v-btn>
                <v-btn color="blue darken-1" text @click="addClientDialog = false">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'AddClientButton',
    props: {
        buttonText: {},
        buttonColor: {}
    },
    data: function() {
        return {
            localButtonText: this.buttonText,
            addClientDialog: false,
            bypass: false,
            prevKeyword: '',
            clientAttrs: {
                clientName: '',
                clientBrand: '',
                clientPhone: '',
                clientEmail: '',
                clientComment: ''
            }
        }
    },

    methods: {
        async checkDuplicateName() {

            if(this.prevKeyword != '' && this.prevKeyword != this.clientAttrs.clientName){
                this.bypass = false
            }

            if(this.bypass != true && this.clientAttrs.clientName.length > 0) {

                const result = await this.$store.dispatch(
                    'checkDuplicateName',
                    {
                        type: 'general',
                        name: this.clientAttrs.clientName
                    }
                )

                if(result == '0000'){
                    this.bypass = true
                    this.prevKeyword = this.clientAttrs.clientName
                    this.$refs.clientName.focus()
                }

            }

        },
        async saveClient() {

            const result = await this.$store.dispatch(
                'saveClient',
                this.clientAttrs
            )

            if(result == '0000'){
                this.addClientDialog = false,
                this.clientAttrs.clientName = '',
                this.clientAttrs.clientBrand = '',
                this.clientAttrs.clientPhone = '',
                this.clientAttrs.clientEmail = ''
                this.bypass = false
                if(this.buttonText){
                    location.reload()
                }
            }

        },
    },
    mounted: function() {
        // this.$refs.client-name.focus()
    }
}
</script>